import React, { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner/PageBanner";
import Sidebar from "../components/Sidebar/Sidebar";
import { supabase } from "../supabaseClient"; // Supabase bağlantımızı import ediyoruz

import { BlogPostCard } from "../components/BlogSection/BlogSection";

import bannerBg from "../assets/images/slider0.jpg";
import "./PatiHikayeleri.scss";
import Loader from "../components/Loader/Loader";
import { useSearchParams } from "react-router-dom";

const PatiHikayeleri = () => {
  // 1. State'leri oluşturuyoruz: post'ları tutmak, yüklenme durumu ve hata durumu için.
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchParams] = useSearchParams();
  const tagFilter = searchParams.get("etiket");

  // 2. useEffect ile component ilk yüklendiğinde verileri çekiyoruz.
  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);

      let query = supabase
        .from("posts")
        .select("*")
        .eq("category", "Pati Hikayeleri")
        .order("created_at", { ascending: false });

      if (tagFilter) {
        query = query.contains("tags", [tagFilter]);
      }

      // Supabase'den veri çekme sorgusu
      const { data, error } = await query;

      if (error) {
        console.error("Error fetching posts:", error);
        setError(error.message);
      } else {
        setPosts(data);
      }

      setLoading(false);
    };

    fetchPosts();
  }, [tagFilter]); // Boş dizi, bu fonksiyonun sadece bir kere çalışmasını sağlar.

  // 3. İçeriği duruma göre render ediyoruz.
  const renderContent = () => {
    if (loading) {
      return <Loader />;
    }
    if (error) {
      return <p>Hikayeler yüklenirken bir hata oluştu: {error}</p>;
    }
    if (posts.length === 0) {
      if (tagFilter)
        return <p>'{tagFilter}' etiketiyle eşleşen bir yazı bulunamadı.</p>;
      return <p>Henüz hiç pati hikayesi eklenmemiş.</p>;
    }
    return posts.map((post) => (
      <BlogPostCard
        key={post.id}
        image={post.image_url}
        date={new Date(post.created_at).toLocaleDateString("tr-TR", {
          day: "numeric",
          month: "long",
        })}
        title={post.title}
        excerpt={post.excerpt}
        // Link'i post'un slug'ına göre dinamik olarak oluşturuyoruz
        url={`/pati-hikayeleri/${post.slug}`}
      />
    ));
  };

  return (
    <div className="paw-stories-page">
      <PageBanner title="Pati Hikayeleri" bgImage={bannerBg} />

      <div className="page-content-wrapper">
        <div className="blog-list-column">{renderContent()}</div>
        <div className="sidebar-column">
          <Sidebar currentCategory="Pati Hikayeleri" />
        </div>
      </div>
    </div>
  );
};

export default PatiHikayeleri;
